import React from 'react';
import styled from 'styled-components';

import useCurrentCourse from '@src/hooks/useCurrentCourse';
import { isPublished, isFundraising, isPreparing } from '@src/utils/course';

import CourseMain from './courseMain';
import CourseDetail from './courseDetail';
import CourseStatus from './courseStatus';

const CourseCardWrapper = styled.div`
	width: 100%;
	padding: 0 20px 12px 20px;
	background-color: #ffffff;

	@media ${props => props.theme.device.lgDesktop} {
		width: 412px;
		padding: 16px;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
	}

	@media ${props => props.theme.device.desktop} {
		width: 340px;
		padding: 16px;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
	}
`;

const CourseMainWrapper = styled(CourseMain)`
	display: none;

	@media ${props => props.theme.device.lgDesktop} {
		display: block;
	}

	@media ${props => props.theme.device.desktop} {
		display: block;
	}
`;

const StyleHr = styled.hr`
	margin-top: 12px;
	border: 0px;
	background-color: #F0F0F0;
	height: 1px;
`;

const CourseCard = (): JSX.Element => {
	const { currentCourse: { status, paid } } = useCurrentCourse();
	const showCourseStatus = (isPublished(status) && !paid) || isFundraising(status) || isPreparing(status);

	return (
		<CourseCardWrapper>
			<CourseMainWrapper />
			<StyleHr />
			<CourseDetail showCourseStatus={showCourseStatus} />
			{showCourseStatus && (<CourseStatus />)}
		</CourseCardWrapper>
	);
};

export default CourseCard;
